var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineHeight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#696E77",
  d: "M5.556 12.281H4.518L7.522 4.1h1.023l3.004 8.182H10.51L8.065 5.394h-.064L5.556 12.28Zm.384-3.196h4.187v.88H5.94z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#696E77",
  d: "M1 14.625h14.063M1 1.5h14.063"
})));
export default SvgLineHeight;